import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';

const ArchiveItem = ({ archive }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  
  if (!archive) return null;
  
  const { year, month, posts = [] } = archive;
  
  // 月份名称
  const monthNames = [
    '一月', '二月', '三月', '四月', '五月', '六月',
    '七月', '八月', '九月', '十月', '十一月', '十二月'
  ];
  
  // 月份猫咪
  const getMonthCat = (month) => {
    const cats = [
      { emoji: '🐈‍⬛', desc: '新年小黑猫' },
      { emoji: '😺', desc: '微笑小橘猫' },
      { emoji: '😸', desc: '开心狸花猫' },
      { emoji: '😻', desc: '爱心波斯猫' },
      { emoji: '😼', desc: '机智暹罗猫' },
      { emoji: '😽', desc: '害羞布偶猫' },
      { emoji: '🙀', desc: '惊讶金吉拉' },
      { emoji: '😿', desc: '流泪短毛猫' },
      { emoji: '😾', desc: '傲娇缅因猫' },
      { emoji: '🐈', desc: '优雅白猫' },
      { emoji: '🐈‍⬛', desc: '神秘黑猫' },
      { emoji: '🐱', desc: '普通小猫咪' }
    ];
    return cats[month - 1] || { emoji: '🐱', desc: '小猫咪' };
  };
  
  // 月份颜色
  const getMonthColor = (month) => {
    const colors = [
      '#FF9AA2', '#FFB7B2', '#FFDAC1', '#E2F0CB', '#B5EAD7', 
      '#C7CEEA', '#D8A7B1', '#B8E1DD', '#FEC8D8', '#FFDFD3',
      '#D9EDF8', '#F0E6EF'
    ];
    return colors[month - 1] || '#A5D8FF';
  };

  const monthName = monthNames[month - 1] || `第${month}月`;
  const monthCat = getMonthCat(month);
  const monthColor = getMonthColor(month);
  const formattedMonth = month < 10 ? `0${month}` : month;

  return (
    <div 
      className={`archive-item ${isExpanded ? 'expanded' : ''}`}
      style={{ '--month-color': monthColor }}
    >
      <div 
        className="month-card"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="month-icon" style={{ backgroundColor: monthColor }}>
          <span className="month-number">{formattedMonth}</span>
          <span className="month-cat-emoji">{monthCat.emoji}</span>
        </div>
        <div className="month-info">
          <div className="month-header">
            <h3 className="month-title">{monthName}</h3>
            <span className="month-badge" style={{ backgroundColor: monthColor }}>
              {posts.length} 篇文章
            </span>
          </div>
          <p className="month-cat-desc">{monthCat.desc}</p>
          <div className="month-actions">
            <span className="toggle-indicator">
              {isExpanded ? '收起' : '展开'} 
              <span className="toggle-icon">{isExpanded ? '▲' : '▼'}</span>
            </span>
          </div>
        </div>
      </div>

      {isExpanded && (
        <div className="month-posts">
          {posts.length > 0 ? (
            <>
              <div className="posts-header">
                <span className="paw-icon">🐾</span>
                <span className="posts-count">本月文章 ({posts.length}篇)</span>
              </div>
              <div className="posts-list">
                {posts.map((post, index) => (
                  <div 
                    key={post.id} 
                    className="post-item"
                    onClick={() => navigate(`/post/${post.id}`)}
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="post-dot" style={{ backgroundColor: monthColor }}></div>
                    <div className="post-content">
                      <div className="post-title-row">
                        <h4 className="post-title">{post.title}</h4>
                        {post.category && (
                          <span className="post-category">{post.category}</span>
                        )}
                      </div>
                      {post.excerpt && (
                        <p className="post-excerpt">{post.excerpt}</p>
                      )}
                      <div className="post-footer">
                        <span className="post-date">
                          📅 {new Date(post.publishDate).toLocaleDateString('zh-CN')}
                        </span>
                        <div className="post-stats">
                          {post.views > 0 && <span>👀 {post.views}</span>}
                          {post.likes > 0 && <span>❤️ {post.likes}</span>}
                          {post.comments > 0 && <span>💬 {post.comments}</span>}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="no-posts">
              <div className="sleeping-cat">😴</div>
              <p>这个月猫咪们都在休息呢~</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ArchiveItem;